import React from "react";
import { GetCorServicei, genURL } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from 'axios'
export default class PopUpOther extends React.Component {
    state = {
        col: [],
        rows: [],
        Htext: "",
        casschkbox: "far fa-square",
        casschkboxs: false,
        docno: "",
        openBackdrop: false,
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {
        this.setState({ openBackdrop: true })
        var dataArray = [];
        this.setState({ sh_Deposit: true });
        this.setState({ docno: this.props.P_DOCNO })
        if (this.props.table === "SaleMan") {
            var url = "CSUSER/All?";
        }
        if (this.props.table === "Groupdata") {
            var url = "CSDOCGROUP/Searchbytbname?tablename=cssaleorder";
        }
        console.log(genURL(url));
        axios.get(genURL(url)).then(res => {
            var j = 0;
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[j] = {
                        number: i + 1,
                        ArCode: res.data[i].Code,
                        Description: res.data[i].MyNameTH,
                        SB: "0",
                    }
                    j++;
                }
                this.setState({ openBackdrop: false })
                this.setState({ products: dataArray });
                this.GetSearchTimeout();
            } else {
                this.setState({ openBackdrop: false })
                dataArray = [];
                this.setState({ products: dataArray });
                this.GetSearchTimeout();
            }
        }).catch(error => {
            this._chkload("Error" + error);
            this.setState({ openBackdrop: false })
        });
        this.setState({ products: dataArray, Htext: "เลือกรายการย่อย" });
    }
    onSelectRow = (data, col, id, row) => {
        if (col > 0 && data.ArCode !== undefined) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.products;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            //------------------------
            var reData = [];
            let j = 0;
            for (var i = 0; i < this.state.products.length; i++) {
                if (this.state.products[i].SB === "1") {
                    reData[j] = {
                        ArCode: this.state.products[i].ArCode,
                        Description: this.state.products[i].Description,
                    }
                    j++
                }
            }
            if (reData.length !== 0) {
                this.props.Get_PopUpSelSaleRef3Sub(reData);
            }
        }
    }
    render() {
        return (

            <div className='popup' /* style={{ zIndex: '100' }} */ >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1">
                            <i className="fas fa-search">{this.state.Htext} </i>
                        </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}>
                            <i className="fas fa-times"></i>
                        </div>
                    </div>
                    <div className="panel-body divTable" align="right">
                        <div style={{ marginTop: "10px" }}>
                            <BootstrapTable
                                data={this.state.products}
                                options={{ onRowClick: this.onSelectRow, noDataText: "ไม่พบข้อมูลที่ค้นหา", }}
                                height="450"
                                hover condensed search>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="20" dataField='number' isKey ><div onClick={this.props.closePopup}><i className="fas fa-reply-all" ></i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="70" dataField='ArCode' > รหัส </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="120" dataField='Description' > ชื่อ/คำอธิบาย </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        {this.state.TableHidden ? ("") : (
                            <button className="PUSDbtn" onClick={this.props.closePopup} >
                                <i className="fas fa-reply-all"> กลับ </i>
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}